import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "tw:flex tw:h-9 tw:w-full tw:rounded-md tw:border tw:border-gray-300 tw:bg-transparent tw:px-3 tw:py-1 tw:text-sm tw:shadow-sm tw:transition-colors file:tw:border-0 file:tw:bg-transparent file:tw:text-sm file:tw:font-medium placeholder:tw:text-gray-400 focus:tw:outline-none focus:tw:border-gray-400 disabled:tw:cursor-not-allowed disabled:tw:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
